// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.users-table-search{width:480px;min-width:33%;max-width:100%}div.oar-organization-and-buttons{display:flex;justify-content:space-between;align-items:center}div.oar-buttons{display:inline-grid;grid-template-columns:1fr 1fr;grid-gap:20px}div.oar-buttons button{padding-left:32px;padding-right:32px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
